import React from 'react'
import UsersTemplate from '../../components/templates/users/UsersTemplate'


const Users = () => {
    return <UsersTemplate/>
}

export default Users
